<template>
  <div>
    <div class="w-full">
      <vx-card title no-shadow card-border>
        <div class="animated fadeIn">
          <div class="vx-row d-flex items-center">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div>
                <div>
                  <span class="header-plan"
                    >{{ $t("setup.label.PlanName") }}: </span
                  ><span v-if="planName">{{ planName }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="version-container">
                <div class="tag">
                  {{ mode === "edit" ? "DRAFT" : planStatus }}
                </div>
                <div class="tag" v-if="planVersion > 0">
                  {{ $t("setup.label.Version") }} :
                  {{
                    planStatus === "ACTIVE" && mode === "edit"
                      ? planVersion + 1
                      : planVersion
                  }}
                </div>
                <div
                  class="tag-approval"
                  v-if="planStatus === 'DRAFT' && mode != 'view'"
                  @click="makerCheckerApproval()"
                >
                  {{ $t("setup.label.requestApproval") }}
                </div>
              </div>
            </div>
          </div>
          <div class="flex mx-4 p-6 gap-10">
            <!-- Rule Types Sidebar -->
            <!-- validationRuleTemplate.ruleExpressionList -->
            <div
              v-if="
                validationRuleTemplate &&
                validationRuleTemplate.ruleExpressionList
              "
              class="w-48 space-y-2 rule-sidebar"
            >
              <vs-button
                v-for="rule in validationRuleTemplate.ruleExpressionList"
                :key="rule.id"
                :class="[
                  'w-full justify-start font-normal',
                  selectedRuleType === rule.codeValue
                    ? 'bg-success text-white'
                    : 'bg-gray',
                ]"
                @click="selectRuleType(rule)"
              >
                {{ rule.name }}
              </vs-button>
            </div>

            <!-- Plan Lists -->
            <div class="dual-listbox-wrapper flex-1">
              <!-- Source Plans -->
              <div class="listbox">
                <div class="listbox-header">
                  <h6 class="text-left font-bold">
                    {{ $t("setup.label.AvailablePlans") }}
                  </h6>
                  <input
                    v-show="mode !== 'view'"
                    v-model="sourcePlanSearch"
                    placeholder="Search..."
                    class="border search-box rounded p-2 w-1/2"
                  />
                </div>
                <div class="listbox-body">
                  <!-- <h4>Available Plans</h4> -->
                  <div v-if="filteredSourcePlans && filteredSourcePlans.length">
                    <li
                      v-for="plan in filteredSourcePlans"
                      :key="plan.id"
                      :class="[
                        'listbox-item',
                        selectedSourcePlan === plan.id ? 'active' : '',
                      ]"
                      @click="onClickSourcePlan(plan)"
                    >
                      {{ plan.planCode }}
                    </li>
                  </div>
                </div>
              </div>

              <!-- Arrows -->
              <div class="arrow-buttons">
                <button
                  class="arrow-button"
                  :disabled="!selectedSourcePlan || mode == 'view'"
                  @click="moveToTarget"
                >
                  <feather-icon icon="ArrowRightIcon" svgClasses="text-dark" />
                </button>
                <button
                  class="arrow-button"
                  :disabled="!selectedTargetPlan || mode == 'view'"
                  @click="moveToSource"
                >
                  <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                </button>
              </div>

              <!-- Target Plans -->
              <div class="listbox">
                <div class="listbox-header">
                  <h6 class="text-left font-bold">
                    {{ $t("setup.label.SelectedPlans") }}
                  </h6>
                  <input
                    v-show="mode !== 'view'"
                    v-model="targetPlanSearch"
                    placeholder="Search..."
                    class="border search-box rounded p-2 w-1/2"
                  />
                </div>
                <div class="listbox-body">
                  <div v-if="filteredTargetPlans && filteredTargetPlans.length">
                    <li
                      v-for="plan in filteredTargetPlans"
                      :key="plan.id"
                      :class="[
                        'listbox-item',
                        selectedTargetPlan === plan.id ? 'active' : '',
                      ]"
                      @click="onClickTargetPlan(plan)"
                    >
                      {{ plan.planCode }}
                    </li>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row center mb-10">
            <div class="vx-col w-full">
              <vs-button
                class="mr-3 footerButton-next"
                v-show="mode != 'view'"
                @click="onClickValidationSubmit"
                >{{ $t("setup.label.Submit") }}</vs-button
              >
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { mapState } from "vuex";

export default {
  props: {
    planId: Number,
    routeId: Number,
    planName: String,
    planVersion: Number,
    planStatus: String,
    mode: String,
  },
  components: {},
  data() {
    return {
      selectedRuleType: "",
      plansByRule: {},
      selectedSourcePlan: null,
      selectedTargetPlan: null,
      sourcePlanSearch: "",
      targetPlanSearch: "",
    };
  },
  computed: {
    ...mapState({
      validationRuleTemplate: (state) =>
        state.planValidationRules.validationRuleTemplate,
      validationRuleData: (state) =>
        state.planValidationRules.validationRuleData,
      planWithTempate: (state) => state.planPrice.planWithTempate,
    }),
    filteredSourcePlans() {
      if (
        !this.plansByRule ||
        !this.plansByRule[this.selectedRuleType] ||
        !this.plansByRule[this.selectedRuleType].sourcePlans
      ) {
        return [];
      }
      return this.plansByRule[this.selectedRuleType].sourcePlans.filter(
        (plan) =>
          plan.planCode
            .toLowerCase()
            .includes(this.sourcePlanSearch.toLowerCase())
      );
    },
    filteredTargetPlans() {
      if (
        !this.plansByRule ||
        !this.plansByRule[this.selectedRuleType] ||
        !this.plansByRule[this.selectedRuleType].targetPlans
      ) {
        return [];
      }
      return this.plansByRule[this.selectedRuleType].targetPlans.filter(
        (plan) =>
          plan.planCode
            .toLowerCase()
            .includes(this.targetPlanSearch.toLowerCase())
      );
    },
  },
  methods: {
    selectRuleType(rule) {
      this.selectedRuleType = rule.codeValue;
    },
    async initializePlansByRule() {
      if (
        !this.validationRuleTemplate ||
        !this.validationRuleTemplate.ruleExpressionList
      )
        return;

      const RulesList = this.validationRuleTemplate.ruleExpressionList;
      const PlansList = this.validationRuleTemplate.planList || [];
      const validationRules = this.validationRuleData;
      RulesList.forEach((rule) => {
        // Get all plans except the currently selected plan
        let sourcePlans = PlansList.filter(
          (plan) => plan.id !== this.planWithTempate.id
        );

        // Find matching rule from API response
        let matchingRule = validationRules.find((r) => r.rule === rule.id);

        // Extract target plans based on checkinPlanId
        let targetPlans = [];
        if (matchingRule && matchingRule.checkinPlanId) {
          const targetPlanIds = matchingRule.checkinPlanId
            .split(",")
            .map((id) => parseInt(id));
          targetPlans = PlansList.filter((plan) =>
            targetPlanIds.includes(plan.id)
          );
        }

        // Remove target plans from source
        sourcePlans = sourcePlans.filter(
          (plan) => !targetPlans.some((tp) => tp.id === plan.id)
        );

        this.$set(this.plansByRule, rule.codeValue, {
          sourcePlans,
          targetPlans,
        });
      });
    },
    moveToTarget() {
      if (!this.selectedSourcePlan) return;
      const rulePlans = this.plansByRule[this.selectedRuleType];

      const planIndex = rulePlans.sourcePlans.findIndex(
        (p) => p.id === this.selectedSourcePlan
      );
      if (planIndex !== -1) {
        const [movedPlan] = rulePlans.sourcePlans.splice(planIndex, 1);
        rulePlans.targetPlans.push(movedPlan);
        this.selectedSourcePlan = null;
      }
    },
    moveToSource() {
      if (!this.selectedTargetPlan) return;
      const rulePlans = this.plansByRule[this.selectedRuleType];

      const planIndex = rulePlans.targetPlans.findIndex(
        (p) => p.id === this.selectedTargetPlan
      );
      if (planIndex !== -1) {
        const [movedPlan] = rulePlans.targetPlans.splice(planIndex, 1);
        rulePlans.sourcePlans.push(movedPlan);
        this.selectedTargetPlan = null;
      }
    },
    async getTemplateData() {
      try {
        await this.$store.dispatch(
          "planValidationRules/getPlanValidationRulesTemplateAction"
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async makerCheckerApproval() {
      try {
        this.$swal({
          title: "Do you want to send approval request?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await this.sendApproval();
              this.$router.push(`/setup/plan-pricing`);
            } catch (error) {
              this.$toasted.error("something went wrong!!");
            }
          }
        });
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async updateValidationRule(payload) {
      try {
        await this.$store.dispatch(
          "planValidationRules/editValidationRuleAction",
          payload
        );
        if (this.routeId) {
          await this.$swal({
            title: "Success",
            icon: "success",
            text: "Validation Rule Updated Successfully!",
            type: "success",
          });
        } else {
          await this.$swal({
            title: "Success",
            icon: "success",
            text: "Validation Rule Created Successfully!",
            type: "success",
          });
        }
        this.$router.push(`/setup/plan-pricing`);
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async sendApproval() {
      try {
        await this.$store.dispatch("planPrice/sendApprovalAction", this.planId);
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Approval request sent!",
          type: "success",
        });
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    onClickSourcePlan(plan) {
      if (this.mode == "view") {
        return;
      } else {
        this.selectedSourcePlan = plan.id;
      }
    },
    onClickTargetPlan(plan) {
      if (this.mode == "view") {
        return;
      } else {
        this.selectedTargetPlan = plan.id;
      }
    },
    async getValidationRulesMethod() {
      try {
        await this.$store.dispatch(
          "planValidationRules/getValidationRulesAction",
          this.planId
        );
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async nextPage() {
      this.activeTab++;
    },
    async onClickValidationSubmit() {
      const inputPlanId = this.planId;
      const validationRules = [];

      Object.keys(this.plansByRule).forEach((ruleCode) => {
        const RulesList = this.validationRuleTemplate.ruleExpressionList;
        const rule = RulesList.find((rule) => rule.codeValue === ruleCode);
        const { targetPlans } = this.plansByRule[ruleCode];

        if (targetPlans.length) {
          const checkinPlanIds = targetPlans.map((plan) => plan.id).join(",");

          // Find existing rule in validationRuleData
          const existingRule = this.validationRuleData.find(
            (e) => e.rule === parseInt(rule.id)
          );
          // const existingRule = validationRulesData.find(e => e.rule === parseInt(rule.id));

          // Construct rule object
          const ruleObj = {
            checkinPlanId: checkinPlanIds,
            ruleAppliesTo: 640,
            rule: parseInt(rule.id),
          };

          // Add id only if the rule exists in validationRuleData
          if (existingRule) {
            ruleObj.id = existingRule.id;
          }

          validationRules.push(ruleObj);
        }
      });

      const payload = {
        id: this.planId,
        data: {
          inputPlanId,
          validationRules,
        },
      };

      await this.updateValidationRule(payload);
    },
    async onApprovalAction(action) {
      try {
        await this.$store.dispatch("planPrice/approvalAction", {
          id: this.approvalId,
          action,
        });
        let msg = action === "approve" ? "Plan Approved" : "Plan Rejected";
        this.$toasted.success(msg, {
          duration: 2000,
        });
        this.$router.push("/makerchecker/approval");
      } catch (error) {
        this.$toasted.error(error.message, {
          duration: 2000,
        });
      }
    },
  },
  async mounted() {
    await this.getTemplateData();
    await this.getValidationRulesMethod();
    await this.initializePlansByRule();
    if (
      this.validationRuleTemplate &&
      this.validationRuleTemplate.ruleExpressionList.length > 0
    ) {
      this.selectedRuleType =
        this.validationRuleTemplate.ruleExpressionList[0].codeValue;
    }
  },
};
</script>
<style scoped lang="scss">
.dual-listbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;
}
.listbox {
  width: -webkit-fill-available;
  height: 300px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  background: #fff;
  display: flex;
  flex-direction: column;
}
.listbox-header {
  background-color: #2e68b266;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.listbox-body {
  overflow-y: auto;
  flex-grow: 1;
  margin: 0;
  padding: 10px;
  list-style: none;
}
.listbox-item {
  padding: 10px;
  cursor: pointer;
  transition: background 0.2s;
}
.listbox-item:hover {
  background-color: #f0f8ff;
}
.listbox-item.active {
  background-color: #e2e9f5;
  font-weight: bold;
}
.arrow-buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.arrow-button {
  padding: 8px;
  border: none;
  background-color: #eee;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 0;
}
.arrow-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
